import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<void, 'disabled' | 'error'>()(
  ({ breakpoints, tokens, px }, _, classes) => ({
    dropzone: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '100%',
      height: px(92),
      border: `${tokens.border.m}px dashed ${tokens.colors.stroke.primary}`,
      borderRadius: tokens.radius.l,

      [`&:not(.${classes.disabled}):not(.${classes.error}):hover`]: {
        borderColor: tokens.colors.stroke.secondary,
      },

      [breakpoints.up('md')]: {
        height: px(140),
      },
    },

    dropzoneMini: {
      width: px(140),
      height: px(140),

      [breakpoints.down('sm')]: {
        width: px(92),
        height: px(92),
      },
    },

    filePreviewPaper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',

      '& > div': {
        width: '100%',
      },
    },

    disabled: {
      backgroundColor: tokens.colors.bg.greyscale.secondary,
      borderStyle: 'solid',
      cursor: 'default',
    },

    active: {
      cursor: 'pointer',
      backgroundColor: tokens.colors.bg.light.primary,
    },

    error: {
      backgroundColor: tokens.colors.accent.bg.error,
      border: `solid ${tokens.colors.accent.text.error} ${tokens.border.s}px`,
    },
  }),
);

export default useStyles;
